module.exports = __webpack_public_path__ + "static/media/checkout.6639c215.svg";